var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Settings } from '@folio/stripes/smart-components';
import GeneralSettings from './GeneralSettings';
var CznaUsersSettings = function (props) {
    var pages = [
        {
            route: 'general',
            label: React.createElement(FormattedMessage, { id: "ui-czna-users.settings.general" }),
            component: GeneralSettings,
        },
    ];
    return (
    // @ts-expect-error - stripes Settings receives location and forceRender from router, not from parent
    React.createElement(Settings, __assign({}, props, { pages: pages, paneTitle: React.createElement(FormattedMessage, { id: "ui-czna-users.settings.title" }) })));
};
export default CznaUsersSettings;
